import { AfterViewInit, Directive, ElementRef, effect, inject, input, signal } from '@angular/core';
import { TranslateService } from './translate.service';
import { TranslateOptions } from './translate.interface';

/**
 * <span translate>ข้อความไทย</span>
 * <span [translate]="'ข้อความไทย'" translateOptions="module"></span>
 */
@Directive({ selector: '[translate]' })
export class TranslateDirective implements AfterViewInit {
  private translate = inject(TranslateService);
  private el: HTMLElement = inject(ElementRef).nativeElement;

  readonly key = input<string>('', { alias: 'translate' });
  readonly translateOptions = input<TranslateOptions>();

  /** ข้อความเดิมใน element เมื่อไม่ได้ส่ง key มา */
  private innerKey = signal('');

  constructor() {
    effect(() => {
      const key = this.key() || this.innerKey();
      if (key) this.el.textContent = this.translate.instant(key, this.translateOptions());
    });
  }

  ngAfterViewInit() {
    if (!this.key()) this.innerKey.set((this.el.textContent ?? '').trim());
  }
}
